import { Object3D } from "three";

import { Context } from "../../../context";
import { Actor } from "../../../world/actor/actor";

import { ControllerStrategy } from "../strategy";

/**
 * Base class useful for camera modes that track players
 */
export abstract class TrackingControllerStrategy extends ControllerStrategy {
  protected posId = -100;

  mound = new Object3D();

  init(context: Context): ControllerStrategy {
    super.init(context);

    // TODO: check removing this doesn't break anything
    // this.mound.position.set(0, 0, -65);
    // this.mound.name = "cam-tracked-mound";

    // if (this.registered?.state.tracked) {
    //   this.registered.state.tracked = this.mound;
    // }

    return this;
  }

  // TODO: roll all this into PositionIdFollowStrategy
  protected findNewActor(
    context: Context,
    newPosId: number
  ): Actor | undefined {
    if (this.posId == newPosId) {
      return undefined;
    }

    this.posId = newPosId;
    return context.world?.actors.getActor(newPosId);
  }
}
